import { getEquipments } from "./manage-equipment.service";

export const getEquipmentForModel = async (modelId: string) => {
    return await getEquipments(
        { modelId: { eq: modelId } },
        false,
        false
    );
};
